import { Directive, forwardRef } from '@angular/core';
import { FormViewAdapter, NGRX_FORM_VIEW_ADAPTER } from 'ngrx-forms';
import { Subscription } from 'rxjs';
import { RichTextEditorComponent } from '../components/rich-text-editor/rich-text-editor.component';

@Directive({
  standalone: false,
  selector: 'rich-text-editor[ngrxFormControlState]',
  providers: [
    {
      provide: NGRX_FORM_VIEW_ADAPTER,
      useExisting: forwardRef(() => RichTextEditorAdapterDirective),
      multi: true,
    },
  ],
})
export class RichTextEditorAdapterDirective implements FormViewAdapter {
  private subscriptions: Subscription[] = [];

  constructor(private richTextEditorComponent: RichTextEditorComponent) {}

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  setViewValue(value: any): void {
    this.richTextEditorComponent.setValue(value);
  }

  setOnChangeCallback(fn: (value: any) => void) {
    this.richTextEditorComponent.valueChanged.subscribe((value) => {
      fn(value);
    });
  }

  setOnTouchedCallback(fn: any): void {
    this.richTextEditorComponent.registerOnTouched(fn);
  }

  setIsDisabled(isDisabled: boolean) {
    this.richTextEditorComponent.setDisabledState(isDisabled);
  }
}
